<div class="content">

  <div class="text-left mt-5">

    <h3>Submit Batch Job specific to that cloud storage</h3> <br>

    <p>Once you are connected to your preferred cloud storage, you can call API to submit
      batch job. Here we will show OCI Object storage example. In previous step, we have connected to
      OCI object storage bucket, now we will submit batch job for video optimizer.</p> <br>

    <h5>Example Request</h5><br>

    <div class="card text-bg-dark mb-3">
      <div class="card-body">
        <div class="card-title">
          <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
            <i class="fa fa-clipboard" aria-hidden="true"></i>
          </button>
            
          <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
            Copied <i class="fa fa-check" aria-hidden="true"></i>
          </button>
    
         </div><br><br>
         
        <pre><code [innerHTML]="batchRequest" ></code></pre>
      </div>
    </div><br>

    <p>You can use different crunch_modes like "video_optimizer" "video_upscaler"
      "image_upscaler" "image_optimizer" "image_enhancer". For details , please refer API documentation.</p><br>

    <h5>Example Response</h5><br>


    <div class="card text-bg-light mb-3">
      <div class="card-body">

        <div class="panel panel-primary">
          <div class="tab-menu-heading">
            <ul class="nav nav-pills" role="tablist">
              <!-- Tab menu items -->
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="tab1" data-bs-toggle="tab" data-bs-target="#content1" type="button"
                  role="tab" aria-controls="content1" aria-selected="true">200</button>
              </li>
            </ul>
          </div>

          <div class="panel-body tabs-menu-body mt-4">
            <div class="tab-content">
              <!-- Tab content -->
              <div class="tab-pane fade show active" id="content1" role="tabpanel" aria-labelledby="tab1">
                <div class="card-body">
                  <pre><code [innerHTML]="batchResponse" ></code></pre>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <br>
    <h3>API doc link:</h3><br>


    <ul>

      <li>
        <a routerLink="/apilist/storage-batchjob" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Storage Batch Job</h5>
        </a>
      </li>
<!-- 
      <li>
        <a routerLink="/apilist/S3Batch" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> S3 Batch</h5>
        </a>
      </li>

      <li>
        <a routerLink="/apilist/dropboxBatch" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Dropbox Batch</h5>
        </a>
      </li>

      <li>
        <a routerLink="/apilist/googledriveBatch" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Google Drive Batch</h5>
        </a>
      </li> -->


    </ul>



    <!-- <p><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/oci-batch">
                http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/oci-batch</a></p>
      
            <p>In Similar way, you can submit batch job for S3, Dropbox and Google Drive, once you
                have authenticated connected to the storage.</p><br> -->


    <!-- <div class="table-responsive">
            
                <table class="table table-light table-hover table-responsive">
                    <thead>
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">Cloud storage</th>
                          <th scope="col">Link</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>S3</td>
                          <td><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/s3-files">
                            http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/s3-files
                           </a></td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>Dropbox</td>
                          <td><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/dropbox-batch">
                            http://cmw-dev-som-documentation.s3-website-us-east1.amazonaws.com/#operation/dropbox-batch
                          </a></td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>Google Drive</td>
                          <td><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/drive-batch">
                            http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/drive-batch</a></td>
                        </tr>
                      </tbody>
                </table>
    
               </div> -->

  </div>


</div>